import { useState, useCallback, useRef } from "react";

export type TranscriptionState =
  | { status: "idle" }
  | { status: "transcribing"; text: string }
  | { status: "done"; text: string }
  | { status: "error"; message: string };

export function useTranscription() {
  const [state, setState] = useState<TranscriptionState>({ status: "idle" });
  const wsRef = useRef<WebSocket | null>(null);

  const start = useCallback(() => {
    wsRef.current?.close();

    const ws = new WebSocket(`ws://${location.host}/transcribe`);
    wsRef.current = ws;

    setState({ status: "transcribing", text: "" });

    ws.onmessage = (event) => {
      const msg = JSON.parse(event.data as string);
      if (msg.type === "word") {
        setState((prev) => ({
          status: "transcribing",
          text: (prev.status === "transcribing" || prev.status === "done" ? prev.text + " " : "") + msg.word,
        }));
      } else if (msg.type === "done") {
        setState((prev) => ({
          status: "done",
          text: prev.status === "transcribing" ? prev.text : "",
        }));
      }
    };

    ws.onerror = () => setState({ status: "error", message: "WebSocket error" });
    ws.onclose = (e) => {
      if (e.code !== 1000 && e.code !== 1001) {
        setState({ status: "error", message: `Connection closed (${e.code})` });
      }
    };
  }, []);

  return { state, start };
}
